import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SupportsTable } from '../../shared/supports-table/supports-table.model';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'arbitrage-disinvestment-form',
    templateUrl: './arbitrage-disinvestment-form.component.html',
    styleUrls: ['./arbitrage-disinvestment-form.component.scss'],
    standalone: false
})
export class ArbitrageDisinvestmentFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  supportsTable: SupportsTable = {
    title: 'Supports à désinvestir',
    totalLabel: 'Total désinvesti',
    emptyLabel: 'Aucun support à désinvestir.',
    columns: [
      { label: 'Support', type: 'support' },
      {
        label: 'Valorisation',
        type: 'amount',
        valueName: 'currentAllocationAmountStock',
        unit: '€',
        digits: '1.4-4',
        total: true,
      },
      {
        label: 'En %',
        type: 'input',
        controlName: 'repartitionStock',
        unit: '%',
        digits: '1.0-4',
        step: '0.0001',
        min: 0,
        max: 100,
        ariaLabel: 'Désinvestissement en pourcentage',
      },
      {
        label: 'En €',
        type: 'input',
        controlName: 'amountRepartitionStock',
        unit: '€',
        digits: '1.2-2',
        step: '0.01',
        min: 0,
        max: row => Number(row.get('currentAllocationAmountStock')?.value) || 0,
        ariaLabel: 'Désinvestissement en euros',
        total: true,
      },
    ],
  };

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  disabledNextBtn(): boolean {
    const arbitrageType = this.arbitrageType;
    if (arbitrageType === 'FLUX') return false;

    const supports = this.supportsDivestment as UntypedFormArray;

    const hasAnyDivestment = supports.controls.some(
      (ctrl: UntypedFormGroup) => {
        const p = Number(ctrl.get('repartitionStock')?.value) || 0;
        const a = Number(ctrl.get('amountRepartitionStock')?.value) || 0;
        return p > 0 || a > 0;
      },
    );

    return this.form.invalid || !hasAnyDivestment;
  }

  hasNotDisinvestment(): boolean {
    const supports = this.supportsDivestment as UntypedFormArray;
    return !supports.controls.some((ctrl: UntypedFormGroup) => {
      const p = Number(ctrl.get('repartitionStock')?.value) || 0;
      const a = Number(ctrl.get('amountRepartitionStock')?.value) || 0;
      return p > 0 || a > 0;
    });
  }

  disinvestAll() {
    const supports = this.supportsDivestment as UntypedFormArray;

    supports.controls.forEach((ctrl: UntypedFormGroup) => {
      const current =
        Number(ctrl.get('currentAllocationAmountStock')?.value) || 0;

      ctrl.get('repartitionStock')?.setValue(100.0);
      ctrl.get('repartitionStock')?.updateValueAndValidity({ emitEvent: true });

      ctrl.get('amountRepartitionStock')?.setValue(Number(current));
      ctrl
        .get('amountRepartitionStock')
        ?.updateValueAndValidity({ emitEvent: true });
    });
  }

  totalStockValue() {
    return (
      this.products.get(`${0}`).get('parameters').get('currentAmountStock')
        .value || 0
    );
  }
}
